<!-- Main Column -->
	<div class="l-row">
		<div class="l-row l-full-width-col">
			<div class="top-data" *ngIf="showNational()">
				<em>Lower 48 working gas in underground storage as of {{latestInventory.date | date:'longDate'}}:&nbsp;</em>
				<span class="data">
					<span class="eia-dashboard-header-values">{{latestInventory.inventory}} Bcf</span> &nbsp;| </span><em>Weekly net change:</em> <span class="change {{getNetChangeSign()}}">
					<span class="eia-dashboard-header-values">{{getAbsoluteNetChange()}} Bcf</span>
				</span>
			</div>
		</div>
	</div>

	<div class="l-row l-two-col-even" *ngIf="showNational()">
		<div class="l-two-col">

			<app-display-eia-single-day-storage-with-gauges *ngIf="displayChart"
																											[title]="'Underground working natural gas storage summary as of '+ (latestInventory.date | date:'longDate')">
			</app-display-eia-single-day-storage-with-gauges>
			<app-display-storage-weekly-working
				[sourceStorage]="'all'"
				[title]="'Lower 48 weekly working gas in underground storage'">
			</app-display-storage-weekly-working>
			<app-display-weekly-net-change
				[sourceStorage]="'all'"
				[title]="'Lower 48 weekly net change in working gas in underground storage'"></app-display-weekly-net-change>
			<app-display-henry-hub
				[title]="'Lower 48 weekly working gas stocks, minus five-year average, and near-month futures prices'">
			</app-display-henry-hub>
		</div>

		<div class="l-two-col">
			<div class="page-nav">
				<div class="left">
					<ul class="left-nav">
						<li [ngClass]="{active: this.mapShown === 'Departure From Normal'}"><a
							(click)="showMap('Departure From Normal')">Departure from Normal</a></li>
						<li [ngClass]="{active: this.mapShown === 'Prior Week'}"><a (click)="showMap('Prior Week')">Weekly
							Change</a></li>
						<li [ngClass]="{active: this.mapShown === 'Daily Animation'}"><a (click)="showMap('Daily Animation')">Daily
							Animation</a></li>
					</ul>
				</div>
			</div>
			<div>
				<app-map-temperature-departure-from-normal *ngIf="this.mapShown === 'Departure From Normal'"
																									 [mapId]="'temperature_departure_from_normal'"
																									 [mapTitle]="'Weekly average departure from normal temperatures as of '"
																										[dataSet]="'departure'"
																										[legend]="this.departureHeatMap">
				</app-map-temperature-departure-from-normal>
				<app-map-temperature-departure-from-normal *ngIf="this.mapShown === 'Prior Week'"
																											 [mapId]="'temperature_departure_from_prior_week'"
																											 [mapTitle]="'Weekly average difference from prior week as of '"
																									 [dataSet]="'weekly change'"
																									 [legend]="this.departurePriorHeatMap">
				</app-map-temperature-departure-from-normal>
				<app-map-daily-animation *ngIf="this.mapShown === 'Daily Animation'"
																 [mapId]="'temperature_departure_daily_animation'"
																 [mapTitle]="'Average daily temperature for '">
				</app-map-daily-animation>
			</div>
			<app-display-eia-pareto
				[chartId]="'daily_us_average_temps'">
			</app-display-eia-pareto>
			<app-gas-consumption
				[consumptionSource]="'electric'"
				[chartTitle]="'Daily Lower 48 natural gas consumption for electricity generation'">
			</app-gas-consumption>
			<app-gas-consumption
				[consumptionSource]="'residential'"
				[chartTitle]="'Daily Lower 48 natural gas consumption for residential/commercial use'">
			</app-gas-consumption>
			<app-nuclear-outages></app-nuclear-outages>
		</div>
	</div>
	
	<div class="l-row l-two-col-even" *ngIf="showRegional()">
		<h1>Regional Natural Gas Storage Stocks</h1>
		<div class="l-two-col">
			<app-display-storage-weekly-working
				[sourceStorage]="'east'"
				[title]="'East region weekly working gas in underground storage'">
			</app-display-storage-weekly-working>
			<app-display-storage-weekly-working
				[sourceStorage]="'midwest'"
				[title]="'Midwest region weekly working gas in underground storage'">
			</app-display-storage-weekly-working>
			<app-display-storage-weekly-working
				[sourceStorage]="'south_central'"
				[title]="'South Central region weekly working gas in underground storage'">
			</app-display-storage-weekly-working>
			<app-display-storage-weekly-working
				[sourceStorage]="'south_central_salt'"
				[title]="'South Central Salt region weekly working gas in underground storage'">
			</app-display-storage-weekly-working>
			<app-display-weekly-net-change
				[sourceStorage]="'south_central_nosalt'"
				[title]="'South Central Nonsalt region weekly net change in working gas in underground storage'">
			</app-display-weekly-net-change>
			<app-display-weekly-net-change
				[sourceStorage]="'mountain'"
				[title]="'Mountain region weekly net change in working gas in underground storage'">
			</app-display-weekly-net-change>
			<app-display-weekly-net-change
				[sourceStorage]="'pacific'"
				[title]="'Pacific region weekly net change in working gas in underground storage'">
			</app-display-weekly-net-change>
		</div>
		<div class="l-two-col">
			<app-display-storage-weekly-working
				[sourceStorage]="'south_central_nosalt'"
				[title]="'South Central Nonsalt region weekly working gas in underground storage'">
			</app-display-storage-weekly-working>
			<app-display-storage-weekly-working
				[sourceStorage]="'mountain'"
				[title]="'Mountain region weekly working gas in underground storage'">
			</app-display-storage-weekly-working>
			<app-display-storage-weekly-working
				[sourceStorage]="'pacific'"
				[title]="'Pacific region weekly working gas in underground storage'">
			</app-display-storage-weekly-working>
			<app-display-weekly-net-change
				[sourceStorage]="'east'"
				[title]="'East region weekly net change in working gas in underground storage'">
			</app-display-weekly-net-change>
			<app-display-weekly-net-change
				[sourceStorage]="'midwest'"
				[title]="'Midwest region weekly net change in working gas in underground storage'">
			</app-display-weekly-net-change>
			<app-display-weekly-net-change
				[sourceStorage]="'south_central'"
				[title]="'South Central region weekly net change in working gas in underground storage'">
			</app-display-weekly-net-change>
			<app-display-weekly-net-change
				[sourceStorage]="'south_central_salt'"
				[title]="'South Central Salt region weekly net change in working gas in underground storage'">
			</app-display-weekly-net-change>
		</div>
	</div>
	<div class="l-row l-two-col-even">
		<h1 *ngIf="showNational()">Prices and Other Indicators</h1>
		<h1 *ngIf="!showNational()">Other Indicators </h1>
		<div class="l-two-col">
			<app-display-eia-heatmap>
			</app-display-eia-heatmap>
		</div>
		<div class="l-two-col" *ngIf="showNational()">
			<app-display-gas-trade-disposition
				[title]="'Daily Lower 48 net natural gas exports (includes pipeline gas and LNG feedstock/sendout changes)'">
			</app-display-gas-trade-disposition>
			<img srcset="{{futureCurveImageURL}}?width=335 335w,
{{futureCurveImageURL}}?width=276 276w,
{{futureCurveImageURL}}?width=512 512w,
{{futureCurveImageURL}}?width=392 392w,
{{futureCurveImageURL}}?width=435 435w"
					 sizes="(max-width: 380px) 276px,
						(max-width: 480px) 335px,
						(max-width: 600px) 392px,
						(max-width: 800px) 512px,
						(max-width: 955px) 392px,
						435px"
					 src="{{futureCurveImageURL}}?width=435" alt="Forward curve for natural gas ">
		</div>
	</div>
	<div class="l-row">
		<div class="l-full-width-col">
			<a href="../dashboard-content/notes_sources.php" class="notation notesAndSources"> <!-- class: lightbox -->
				<span class="ico info"></span>Notes, sources, and related links
			</a>
			<p class="feedback">Have a question, comment, or suggestion? Send your feedback to <a href="mailto:natgasstoragedashboard@eia.gov">natgasstoragedashboard@eia.gov</a></p>
		</div>
	</div>
	<div class="push"></div>
<!-- /div -->



// WEBPACK FOOTER //
// ./src/app/dashboard/display-dashboard/display-dashboard.component.html